import { DTOProductsObjectiveBased } from '../../../strategies/ObjectiveBased/dto'

type MinCostDTOProps = {
  selectedProducts: Product[]
  goal: Goals
  publisherId: PublisherId
  period: CallbackDateInterval
}

export const minCostDTO = ({
  selectedProducts,
  goal,
  publisherId,
  period
}: MinCostDTOProps) =>
  ({
    ad_type: 'product',
    strategy_type: 'objective_based',
    publisher_id: publisherId,
    products: DTOProductsObjectiveBased(selectedProducts || []),
    goal,
    start_at: period.startDate,
    ...(period.endDate ? { end_at: period.endDate } : {}),
    settings: {
      daily_budget: '0',
      cpc: '0',
      cpm: '0'
    }
  }) as GetMinCostsRequestBody
